/*
 * @Date: 2021-05-17 14:37:54
 * @Author: zhujuan
 * @LastEditors: zhujuan
 * @LastEditTime: 2022-01-18 18:07:13
 */

import { Notification, Message, MessageBox } from 'win-design'

export default {
  data() {
    return {}
  },

  methods: {
    $go(para) {
      this.$router.push({ path: `${para}` })
    },
    $back(num) {
      const back = num | -1
      this.$router.go(back)
    },
    $home() {
      this.$router.push({ path: '/home' })
    },

    // 二次确认弹框
    $comfirm(message, options = {}) {
      const title = options.title || '提示'
      return new Promise((resolve, reject) => {
        MessageBox.confirm(message, title, {
          confirmButtonText: options.confirmButtonText || '确定', // 自定义确认按钮文字
          cancelButtonText: options.cancelButtonText || '取消', // 自定义取消文字
          dangerouslyUseHTMLString: options.dangerouslyUseHTMLString || false, // 内容是否用html显示
          center: false,
          showCancelButton:
            options.showCancelButton === false
              ? options.showCancelButton
              : true, // 是否显示取消按钮
          closeOnClickModal:
            options.closeOnClickModal === false
              ? options.closeOnClickModal
              : true, // 是否显示取消按钮
          type: 'warning'
          // closeOnClickModal: false, // 是否可通过点击遮罩关闭 MessageBox
        })
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 右上角轻提示 type  success/warning/info/error
    $notice(message, type) {
      Notification({
        title: '成功',
        message: message,
        type: type || 'success',
        duration: '2000'
      })
    },

    // 顶部message  type error-错误 success-成功 warning-警告  info-普通消息
    $msg(message, type, duration) {
      Message({
        message,
        type: type || 'error',
        duration: duration || '2000'
      })
    }
  }
}
